/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import { COLORS } from 'colors';

export const Section = styled.section`
  padding: 3rem 1rem;
  @media (min-width: 1024px) {
    padding: 2rem 5rem 2rem 5rem;
  }
`;
export const FeaturesV2 = styled.div`
  max-width: 1440px;
  margin: 0 auto;
`;
export const Container = styled.div`
`;
export const Grid = styled.div`
  display: flex;
  flex-direction: ${({ colReverse }) => (colReverse ? 'column-reverse' : 'column')};
  gap: 3rem;
  align-items: center;
  .content-grid {
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 343px;
  }
  .img-grid {
    width: 343px;
    height: 258px;
    border-radius: 0.5rem;
    object-fit: cover;
    overflow: hidden;
  }
  @media (min-width: 1280px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    flex-direction: unset;
    gap: 6rem;
  }
  @media (min-width: 768px) {
    .content-grid {
      max-width: 480px;
    }
    .img-grid {
      width: 700px;
      height: 489px;
    }
  }
`;

export const Heading = styled.h1`
  font-size: 34px;
  line-height: 114.9%;
  font-weight: 600;
  color: ${COLORS.DARK_BLUE};
  letter-spacing: -2px;
  span {
    color: ${COLORS.ORANGE_GRADIENT};
  }

  @media (min-width: 1024px) {
    font-size: 3rem;
  }
`;
export const SubHeading = styled.h2`
  font-size: 34px;
  line-height: 114.9%;
  font-weight: 600;
  letter-spacing: -3px;
  color: ${COLORS.DARK_BLUE};

  span {
    color: ${COLORS.ORANGE_GRADIENT};
  }

  @media (min-width: 1024px) {
    font-size: 3rem;
  }
`;
export const Paragraph = styled.p`
  color: ${COLORS.GRAY_700};
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  letter-spacing: 0;
  @media (min-width: 767px) {
    font-size: 20px;
    line-height: 30px;
  }
`;
